<form *ngIf="!isFetching" [formGroup]="form" [class.show-errors]="showErrors" (submit)="submit()">
  <mat-form-field appearance="standard" color="standart">
    <mat-label>{{'password.reset.password' | translate}}</mat-label>
    <input type="password" matInput formControlName="password">
  </mat-form-field>

  <mat-form-field appearance="standard" color="standart">
    <mat-label>{{'password.reset.confirmPassword' | translate}}</mat-label>
    <input type="password" matInput formControlName="confirmPassword">
  </mat-form-field>
  <div class="d-flex">
    <button mat-flat-button color="primary" class="action-button" (click)="submit()" style="width: 180px">{{"password.reset.submit" | translate}}</button>
  </div>
</form>
